var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LicenseState } from "@/app/store/modules/license.state";
import { LicenseClient, AssureEditionEnum, HostingOptionEnum, LicenseStatus } from "@/app/api/battery-portal-api";
const licenseClient = new LicenseClient(window.apiUrl);
export const state = new LicenseState();
const getters = {
    appEdition(state) {
        return state.appEdition;
    },
    hostingOption(state) {
        return state.hostingOption;
    },
    licenseStatus(state) {
        return state.status;
    },
    statusDisplayLabel(state) {
        return state.statusDisplayLabel;
    },
    isLicenseValid(state) {
        return state.isValid;
    },
    isDefaultLicense(state) {
        return state.isDefaultLicense;
    },
    isClockTampered(state) {
        return state.isClockTampered;
    },
    remainingDays(state) {
        return state.remainingDays;
    },
    isDefaultLicenseActive(state) {
        return state.isDefaultLicense;
    },
    isBasicEdition(state) {
        return state.isBasicEdition;
    },
    isStandardEdition(state) {
        return state.isStandardEdition;
    },
    isPremiumEdition(state) {
        return state.isPremiumEdition;
    },
    isStandardOrHigher(state) {
        return state.isStandardEdition || state.isPremiumEdition;
    },
    isOnPrem(state) {
        return state.isOnPrem;
    },
    isCloud(state) {
        return state.isCloud;
    },
    isActiveOrGracePeriod(state) {
        return state.isActiveOrGracePeriod;
    },
    hasFeatureAccess: (state) => (minimumEdition) => {
        if (state.isClockTampered)
            return false;
        if (!state.isActiveOrGracePeriod)
            return false;
        const editionHierarchy = [
            AssureEditionEnum.OnPremBasic,
            AssureEditionEnum.OnPremStandard,
            AssureEditionEnum.OnPremPremium,
            AssureEditionEnum.PowershieldCloudStandard
        ];
        const currentIndex = editionHierarchy.indexOf(state.appEdition);
        const requiredIndex = editionHierarchy.indexOf(minimumEdition);
        if (state.appEdition === AssureEditionEnum.PowershieldCloudStandard)
            return true;
        return currentIndex >= requiredIndex;
    }
};
export const mutations = {
    setLicenseSummary(state, summary) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        state.appEdition = (_a = summary.appEdition) !== null && _a !== void 0 ? _a : AssureEditionEnum.OnPremBasic;
        state.hostingOption = (_b = summary.hostingOption) !== null && _b !== void 0 ? _b : HostingOptionEnum.OnPrem;
        state.status = (_c = summary.status) !== null && _c !== void 0 ? _c : LicenseStatus.NotChecked;
        state.statusDisplayLabel = (_d = summary.statusDisplayLabel) !== null && _d !== void 0 ? _d : "Unknown";
        state.isValid = (_e = summary.isValid) !== null && _e !== void 0 ? _e : false;
        state.isDefaultLicense = (_f = summary.isDefaultLicense) !== null && _f !== void 0 ? _f : false;
        state.remainingDays = (_g = summary.remainingDays) !== null && _g !== void 0 ? _g : null;
        state.endDate = (_h = summary.endDate) !== null && _h !== void 0 ? _h : null;
        state.gracePeriodSecs = (_j = summary.gracePeriodSecs) !== null && _j !== void 0 ? _j : null;
    },
    resetLicense(state) {
        state.reset();
    }
};
export const actions = {
    loadLicense(_a) {
        return __awaiter(this, arguments, void 0, function* ({ commit }) {
            try {
                const summary = yield licenseClient.getLicenseSummary();
                commit("setLicenseSummary", summary);
            }
            catch (error) {
                console.error("Failed to load license summary:", error);
            }
        });
    },
    refreshLicense(_a) {
        return __awaiter(this, arguments, void 0, function* ({ commit }) {
            try {
                const summary = yield licenseClient.getLicenseSummary();
                commit("setLicenseSummary", summary);
            }
            catch (error) {
                console.error("Failed to refresh license:", error);
            }
        });
    },
    resetLicense({ commit }) {
        commit("resetLicense");
    }
};
const namespaced = true;
export const licenseModule = {
    namespaced,
    state,
    actions,
    mutations,
    getters
};
